// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__qn9dv","rootSuccess":"CompleteLink_rootSuccess__25au2","rootFailure":"CompleteLink_rootFailure__3Tx-x","isDisabled":"CompleteLink_isDisabled__24vyg"};